import { Stack } from "@mui/material";
import PaymentRequestFilters from "./components/filters/PaymentRequestFilters";
import PaymentRequestTable from "./components/tables/PaymentRequestTable";
import OutstandingManagementTable from "./components/tables/OutstandingManagementTable";
import OutstandingManagementFilters from "./components/filters/OutstandingManagementFilters";

function PaymentRequest(props: { outstanding: boolean }) {
  return (
    <Stack direction={"column"} spacing={2} margin={"16px"}>
      {props.outstanding ? (
        <>
          <OutstandingManagementFilters />
          <OutstandingManagementTable />
        </>
      ) : (
        <>
          <PaymentRequestFilters />
          <PaymentRequestTable />
        </>
      )}
    </Stack>
  );
}

export default PaymentRequest;
